import React from 'react';

import { Chip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  chip_success: {
    color: theme.palette.success.contrastText,
    backgroundColor: theme.palette.success.main,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
    '&:focus': {
      backgroundColor: theme.palette.success.dark,
    },
  },
  chip_info: {
    color: theme.palette.info.contrastText,
    backgroundColor: theme.palette.info.main,
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    },
    '&:focus': {
      backgroundColor: theme.palette.info.dark,
    },
  },
  chip_error: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
    '&:focus': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  chip_warning: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
    '&:focus': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  gutterRight: {
    marginRight: '5px',
  },
}));

// COMPONENT
function ChipStatus({ status, label, gutterRight, className, ...rest }) {
  const { classes, cx } = useStyles();

  return (
    <Chip
      color="primary"
      label={label}
      classes={{
        colorPrimary: classes[`chip_${status ?? 'info'}`],
      }}
      className={cx(className, gutterRight && classes.gutterRight)}
    />
  );
}

export default ChipStatus;
